import { ConfigProvider, Menu, MenuProps, Popover } from 'antd';
import React, { useEffect, useState } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import GlobalButton from './GlobalButton';
import {
  greyColor, maxMobile, maxTablet, maxWidth, primaryColor, primaryFont, retina, wMedium,
} from '../../../Utils/utilsStyle';
import DownAngleIcon from '../assets/svgIcons/DownAngleIcon';
import classNames from 'classnames';
import { IsMobile, IsTablet } from '../../../Utils/UtilityFunctions';
import WorldIcon from '../assets/svgIcons/WorldIcon';
import IndustriesSvg from '../../layout/assets/IndustriesSvg';
import CompanyRevenueIcon from '../assets/svgIcons/CompanyRevenueIcon';
import CompanySizeIcon from '../assets/svgIcons/CompanySizeIcon';
import SubFilterComponent, { SubFilterOption } from './SubFilterComponent';
import { AdvancedSearchMetadataIndustry } from '../../../Types/AdvanceSearchResultsTypes';
import { CompanyFiltersType, SubFilterSelection } from '../../../Types/GlobalTypes';
import FilterNewIcon from '../assets/svgIcons/FilterNewIcon';

const CompanyFiltersPopupStyle = createGlobalStyle`
  .ant-popover.company-filters-popup {
  @media all and (max-width: ${maxMobile}) {
    overflow: visible !important;
    .ant-popover-content,
    .ant-popover-inner,
    .ant-popover-inner-content {
      overflow: visible !important;
    }
  }
  .ant-popover-content {
    width: 300px !important;
    .ant-popover-inner {
     
      border: 1px solid #DADADA;
      background: #FFF;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.15);
      width: fit-content;
      padding: 10px 4px;
      .ant-popover-inner-content {
        width: unset !important;
        height: unset !important;
        padding: 0px !important;
        .menu-for-company-filters {
          border-inline-end: unset;
          .ant-menu-submenu {
            width: 100%;
            margin: 0 !important;
            border-radius: 0;
            &.ant-menu-submenu-active {
              background: #F1F1F1;
              border-radius: 6px;
              .ant-menu-submenu-title {
                &:active {
                  background: unset;
                }
                svg {
                  color: ${primaryColor};
                  path {
                    fill: ${primaryColor};
                  }
                }
                .company-size-icon {
                  path {
                    stroke: ${primaryColor} !important;
                  }
                }
                .ant-menu-title-content {
                  color: ${primaryColor};
                }
              }
            }
            .ant-menu-submenu-title {
              display: flex;
              align-items: center;
              column-gap: 9px;
              width: 100%;
              height: 32px;
              margin: 0 !important;
              padding-inline: 16px 16px !important;
              border-radius: 6px;
              .industries-svg, .world-icon-svg, .company-revenue-icon, .company-size-icon {
                width: 18px;
                height: 18px;
              }
              .ant-menu-title-content {
                flex: 1;
                width: 100%;
                color: ${greyColor};
                font-family: ${primaryFont};
                font-size: 16px;
                font-weight: ${wMedium};
                line-height: 20px;
              }
              .down-angle-icon {
                position: absolute;
                right: 16px;
                transform: rotate(269deg);
              }
            }
            &.active-filter-item {
              .ant-menu-submenu-title {
                svg {
                  color: ${primaryColor};
                  path {
                    fill: ${primaryColor};
                  }
                }
                .ant-menu-title-content {
                  color: ${primaryColor};
                }
              }
            }
          }
        }
      }
    }
  }
  }
`;

const StyleWrapper = styled.div`
  .company-filters-popover {
    button {
      @media all and (max-width: ${maxTablet}) {
        width: 31px;
        height: 28px;
        padding: 0px;
        margin: 0px;
        -webkit-box-pack: center;
        justify-content: center;  
      }
      .separator-right {
        margin: 0px 5px 0px 10px;
        background-color: #DDD;
      }
      &.activeBtnState {
        .down-angle-icon {
          transform: rotate(180deg);
        }
      }
    }
  }
`;

const SubMenuPopupStyle = createGlobalStyle`
  .ant-menu-submenu-popup.sub-menu-for-company-filters {
    z-index: 1 !important;
    .ant-menu {
      min-width: auto !important;
      padding: 0 !important;
      border: 1px solid #DADADA;
      border-radius: 8px;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.15);
    }
    @media all and (max-width: ${maxMobile}) {
      .ant-popover.company-filters-popup & {
        position: absolute !important;
        top: calc(100% + 8px) !important;
        right: 0 !important;
        bottom: auto !important;
        left: 0 !important;
        width: 290px !important;
        min-width: 290px !important;
        max-width: 290px !important;
        margin: 0 !important;
        transform: none !important;
        .ant-menu {
          width: 100% !important;
        }
        .sub-filter-item-wrap > div {
          width: 100% !important;
          max-width: 100%;
        }
      }
    }
    .ant-menu-item.sub-filter-menu-item,
    .sub-filter-menu-item {
      height: auto !important;
      line-height: normal !important;
      margin: 0 !important;
      padding: 0 !important;
      background: transparent !important;
      cursor: default;
      width: 100% !important;
      &:hover,
      &.ant-menu-item-active,
      &.ant-menu-item-selected {
        background: transparent !important;
      }
    }
  }
`;
const ContentWrapper = styled.div`
.reset-button {
    display: inline-flex;
    justify-content: flex-end;
    width: 100%;
    padding-right: 16px;
    color: ${primaryColor};
    font-family: ${primaryFont};
    font-size: 14px;
    font-weight: ${wMedium};
    line-height: 20px;
    letter-spacing: -0.4px;
    cursor: pointer;
    &.disabled {
      opacity: 0.5;
      pointer-events: none;
    }
  }
`;

type CompanyFiltersValue = CompanyFiltersType;
type CompanyDraftFilters = {
  [K in keyof CompanyFiltersType]?: SubFilterSelection;
};

type Props = {
  industryData: AdvancedSearchMetadataIndustry[]
  revenueData: string[]
  regionData: string[]
  companySizeData: string[]
  initialFilters?: CompanyFiltersValue
  onApply?: (filters: CompanyFiltersValue) => void;
  disabled?: boolean
};

const defaultProps = {
  industryData: [],
  revenueData: [],
  regionData: [],
  companySizeData: [],
  initialFilters: {},
  disabled: false,
};

type MenuItem = Required<MenuProps>['items'][number] & { children?: MenuItem[] };

function getItem(
  label: React.ReactNode,
  key?: React.Key | null,
  icon?: React.ReactNode,
  children?: MenuItem[],
  extra?: Record<string, unknown>,
): MenuItem {
  return {
    key, icon, children, label, ...extra,
  } as MenuItem;
}

const emptySelection = (): SubFilterSelection => ({
  all: true,
  selected: [],
  excluded: [],
});

const getSubFilterChild = (
  category: string,
  title: string,
  data: SubFilterOption[],
  selection: SubFilterSelection,
  applyDisabled: boolean,
  onSelectionChange: (selection: SubFilterSelection) => void,
  onApply: (category: string, selection: SubFilterSelection) => void,
) => getItem(
  <div
    className="sub-filter-item-wrap"
    onClick={(e) => e.stopPropagation()}
    onMouseDown={(e) => e.stopPropagation()}
    onKeyDown={(e) => e.stopPropagation()}
    role="presentation"
  >
    <SubFilterComponent
      category={category}
      title={title}
      data={data}
      selection={selection}
      applyDisabled={applyDisabled}
      onSelectionChange={onSelectionChange}
      onApply={onApply}
    />
  </div>,
  `${category}-panel`,
  undefined,
  undefined,
  { className: 'sub-filter-menu-item' },
);

const CompanyFilters = (props: Props) => {
  const {
    revenueData, companySizeData, industryData, regionData, initialFilters, onApply, disabled
  } = props;

  const [open, setOpen] = useState(false);
  const [openKeys, setOpenKeys] = useState<string[]>([]);
  const isMob = IsMobile();
  const isTab = IsTablet();
  const subMenuExtra = { popupClassName: 'sub-menu-for-company-filters' };

  const [filters, setFilters] = useState<CompanyFiltersValue>({});
  const [selectedFilters, setSelectedFilters] = useState<CompanyDraftFilters>({});
  const [appliedSelections, setAppliedSelections] = useState<CompanyDraftFilters>({});

  const isResetDisabled = Object.values(filters).every(
    (selection) => selection?.all === true
  );

  const normalizeSelection = (selection: SubFilterSelection): SubFilterSelection => (
    selection.all
      ? {
        all: true,
        selected: [],
        excluded: [...selection.excluded],
      }
      : {
        all: false,
        selected: [...selection.selected],
        excluded: [],
      }
  );

  const areArraysEqual = (first: string[], second: string[]) => {
    if (first.length !== second.length) return false;

    const firstSet = new Set(first);
    const secondSet = new Set(second);

    return [...firstSet].every((option) => secondSet.has(option));
  };

  const areSelectionsEqual = (
    first: SubFilterSelection,
    second: SubFilterSelection,
  ) => {
    if (first.all !== second.all) {
      return false;
    }
    if (first.all) {
      return areArraysEqual(first.excluded, second.excluded);
    }
    return areArraysEqual(first.selected, second.selected);
  };

  const areFiltersEqual = (first: CompanyFiltersValue, second: CompanyFiltersValue) => {
    const categories: (keyof CompanyFiltersType)[] = [
      'industry', 'revenue', 'region', 'companySize',
    ];

    return categories.every((category) => areArraysEqual(
      first[category] ?? [],
      second[category] ?? [],
    ));
  };

  const getOptionNames = (data: SubFilterOption[]) => data.map((option) => (
    typeof option === 'string' ? option : option.name
  )).filter(Boolean);

  const getSelection = (category: keyof CompanyFiltersType): SubFilterSelection => (
    selectedFilters[category] ?? emptySelection()
  );

  const getAppliedSelection = (category: keyof CompanyFiltersType): SubFilterSelection => (
    appliedSelections[category] ?? emptySelection()
  );

  const isApplyDisabled = (category: keyof CompanyFiltersType) => (
    areSelectionsEqual(getSelection(category), getAppliedSelection(category))
  );

  const convertFiltersToDraft = (source: CompanyFiltersValue): CompanyDraftFilters => {
    const draft: CompanyDraftFilters = {};

    Object.entries(source).forEach(([category, values]) => {
      if (values) {
        draft[category as keyof CompanyFiltersType] = {
          all: false,
          selected: values,
          excluded: [],
        };
      }
    });

    return draft;
  };

  useEffect(() => {
    const nextFilters = initialFilters ?? {};

    if (areFiltersEqual(nextFilters, filters)) {
      return;
    }

    const nextDraft = convertFiltersToDraft(nextFilters);
    setFilters(nextFilters);
    setSelectedFilters(nextDraft);
    setAppliedSelections(nextDraft);
  }, [initialFilters]);

  const getCategoryOptionNames = (category: keyof CompanyFiltersType) => {
    const dataByCategory: Record<keyof CompanyFiltersType, SubFilterOption[]> = {
      industry: industryData,
      revenue: revenueData,
      region: regionData,
      companySize: companySizeData,
    };

    return getOptionNames(dataByCategory[category] ?? []);
  };

  const toParentFilters = (
    current: CompanyFiltersValue,
    category: keyof CompanyFiltersType,
    selection: SubFilterSelection,
  ): CompanyFiltersValue => {
    const nextFilters = { ...current };

    if (selection.all && selection.excluded.length === 0) {
      delete nextFilters[category];
      return nextFilters;
    }

    if (selection.all) {
      nextFilters[category] = getCategoryOptionNames(category).filter(
        (name) => !selection.excluded.includes(name),
      );
      return nextFilters;
    }

    nextFilters[category] = selection.selected;
    return nextFilters;
  };

  const isCategoryActive = (category: keyof CompanyFiltersType) => {
    const appliedSelection = getAppliedSelection(category);

    if (appliedSelection.all) {
      return appliedSelection.excluded.length > 0;
    }

    return appliedSelection.selected.length > 0;
  };

  const hasActiveFilters = isCategoryActive('industry')
    || isCategoryActive('revenue')
    || isCategoryActive('region')
    || isCategoryActive('companySize');

  const getMenuItemExtra = (category: keyof CompanyFiltersType) => ({
    ...subMenuExtra,
    className: classNames({ 'active-filter-item': isCategoryActive(category) }),
  });

  const handleSubFilterChange = (
    category: keyof CompanyFiltersType,
    selection: SubFilterSelection,
  ) => {
    setSelectedFilters((currentFilters) => ({
      ...currentFilters,
      [category]: selection,
    }));
  };

  const handleSubFilterApply = (
    category: string,
    selection: SubFilterSelection,
  ) => {
    const filterCategory = category as keyof CompanyFiltersType;
    const normalized = normalizeSelection(selection);
    const nextFilters = toParentFilters(filters, filterCategory, normalized);

    const nextDraft = {
      ...appliedSelections,
      [filterCategory]: normalized,
    };

    setOpenKeys([]);
    setOpen(false);

    setFilters(nextFilters);
    setSelectedFilters(nextDraft);
    setAppliedSelections(nextDraft);

    requestAnimationFrame(() => {
      onApply?.(nextFilters);
    });
  };

  const items: MenuItem[] = [
    getItem('Industry', 'industry', <IndustriesSvg color="#7E7E7E" />, [getSubFilterChild('industry', 'Industry', industryData, getSelection('industry'), isApplyDisabled('industry'), (selection) => handleSubFilterChange('industry', selection), handleSubFilterApply)], getMenuItemExtra('industry')),
    getItem('Revenue', 'revenue', <CompanyRevenueIcon />, [getSubFilterChild('revenue', 'Revenue', revenueData, getSelection('revenue'), isApplyDisabled('revenue'), (selection) => handleSubFilterChange('revenue', selection), handleSubFilterApply)], getMenuItemExtra('revenue')),
    getItem('Region', 'region', <WorldIcon color="#7E7E7E" />, [getSubFilterChild('region', 'Region', regionData, getSelection('region'), isApplyDisabled('region'), (selection) => handleSubFilterChange('region', selection), handleSubFilterApply)], getMenuItemExtra('region')),
    getItem('Company Size', 'companySize', <CompanySizeIcon />, [getSubFilterChild('companySize', 'Company Size', companySizeData, getSelection('companySize'), isApplyDisabled('companySize'), (selection) => handleSubFilterChange('companySize', selection), handleSubFilterApply)], getMenuItemExtra('companySize')),
  ];

  const onOpenChange = (keys: string[]) => {
    const latestKey = keys.find((key) => !openKeys.includes(key));
    setOpenKeys(latestKey ? [latestKey] : keys);
  };

  const resetFilters = () => {
    setSelectedFilters({});
    setAppliedSelections({});
    setFilters({});
    setOpenKeys([]);
    setOpen(false);
    onApply?.({});

  };

  const content = (
    <ContentWrapper>
      <Menu
        style={{ width: isMob ? 230 : 274, borderRadius: 8 }}
        mode="vertical"
        items={items}
        expandIcon={<DownAngleIcon color="rgba(126, 126, 126, 1)" />}
        className="menu-for-company-filters"
        triggerSubMenuAction="click"
        openKeys={openKeys}
        subMenuCloseDelay={0}
        motion={{
          motionName: '',
          motionAppear: false,
          motionEnter: false,
          motionLeave: false,
        }}
        onOpenChange={onOpenChange}
        getPopupContainer={(node) => (
          isMob
            ? (node.closest('.company-filters-popup') as HTMLElement) || document.body
            : document.body
        )}
      />
      <span
        className={classNames("reset-button", { disabled: isResetDisabled })}
        role='button'
        tabIndex={0}
        onClick={resetFilters}
      >
        Reset
      </span>
    </ContentWrapper>
  );

  return (
    <ConfigProvider theme={{ token: { motion: false } }}>
      <StyleWrapper>
        <CompanyFiltersPopupStyle />
        <SubMenuPopupStyle />
        <Popover
          style={{ width: isMob ? 230 : 274, borderRadius: 8 }}
          placement="bottomLeft"
          content={content}
          trigger="click"
          open={open}
          destroyOnHidden
          transitionName=''
          onOpenChange={(newOpen) => {
            setOpen(newOpen);
            if (!newOpen) {
              setOpenKeys([]);
            }
          }}
          getPopupContainer={() => document.body}
          className="company-filters-popover"
          rootClassName="company-filters-popup"
          arrow={false}
          zIndex={1}
        >
          <div
            aria-hidden="true"
            onClick={(e) => { e.stopPropagation(); }}
          >
            <GlobalButton
              title={isTab ? " " : "Filter"}
              outlineColor={open || hasActiveFilters ? primaryColor : '#DADADA'}
              textColor={open || hasActiveFilters ? primaryColor : '#7E7E7E;'}
              bgColor={open || hasActiveFilters ? '#E8F8EC;' : '#fff'}
              innerSpace="9px 12px"
              onButtonClick={() => { }}
              RightSeparator={isTab ? false : true}
              height="38px"
              IconRight={isTab ? <FilterNewIcon /> : <DownAngleIcon color={open || hasActiveFilters ? primaryColor : 'rgba(126, 126, 126, 1)'} />}
              buttonClassName={classNames({ activeBtnState: open })}
              disabled={disabled}
              loading={disabled}
            />
          </div>
        </Popover>
      </StyleWrapper>
    </ConfigProvider>
  );
};

CompanyFilters.defaultProps = defaultProps;
export default CompanyFilters;